import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";

const companyLabel = (option) => option?.companyName || option?.name || "";

const sameCompany = (option, value) => {
  if (!option || !value) return false;
  const optionId = option._id || option;
  const valueId = value._id || value;
  return String(optionId) === String(valueId);
};

export default function CompanySelect({
  options = [],
  value,
  onChange,
  placeholder = "Select company",
  disabled = false,
}) {
  const list = Array.isArray(options) ? options : [];
  let selected = null;
  if (value && typeof value === "object") {
    selected =
      list.find((item) => sameCompany(item, value)) ||
      (value.companyName || value.name ? value : null);
  } else if (value) {
    selected = list.find((item) => String(item._id) === String(value)) || null;
  }

  return (
    <Autocomplete
      options={list}
      value={selected}
      disabled={disabled}
      onChange={(_, next) => onChange?.(next)}
      getOptionLabel={companyLabel}
      isOptionEqualToValue={sameCompany}
      slotProps={{ popper: { sx: { zIndex: 20000 } } }}
      renderOption={(props, option) => (
        <Box component="li" {...props} key={option?._id || companyLabel(option)}>
          {companyLabel(option)}
        </Box>
      )}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} size="small" />
      )}
    />
  );
}
